import { ReactElement } from "react";
import * as React from "react";
import styles from "./AiAssist.module.scss"
import QuickActionLinks from "../../components/ai-assist-refactored/QuickActionLinks";
import AssistanceTask from "../../components/ai-assist-refactored/assistance-task/AssistanceTask";
import ManualTask from "../../components/ai-assist-refactored/assistance-task/ManualTask";
import { useLoadingFlag } from "@me8eon/async";

type AiAssistProps = {
    //TODO: Remove after old header is deprecated. It should be an Outlet component for nested routes, https://api.reactrouter.com/v7/functions/react_router.Outlet.html
    headerToggle: ReactElement;
    messagesWindow: ReactElement
    promptArea: ReactElement
    disclaimer: ReactElement
    suggestions: ReactElement
    isEmptyPage?: boolean
    assistanceActions: ReactElement
    manualActions: ReactElement
}

export const AiAssistTemplate = (props: AiAssistProps) => {
    const { messagesWindow, promptArea, disclaimer, headerToggle, suggestions, assistanceActions, manualActions } = props
    const [isLoading] = useLoadingFlag();

    return (
        <div className={styles.aiAssistant}>
            {/*/!*TODO: Remove after old header is deprecated. It should be an Outlet component for nested routes, https://api.reactrouter.com/v7/functions/react_router.Outlet.html*!/*/}
            {headerToggle}
            <div className={styles.aiAssistant__messageList}>
                <div className={styles.aiAssistant__messagesWrapper} style={{ ...(props.isEmptyPage ? { width: "100%" } : {}) }}>
                    {messagesWindow}
                </div>
                {!isLoading && <div className={styles.aiAssistant__desktopActions}>
                    <div style={{ position: "sticky", top: "120px" }}>
                        <QuickActionLinks />
                        {assistanceActions}
                        {manualActions}
                    </div>
                </div>}
            </div>
            <div className={styles.aiAssistant__promptArea}>
                {suggestions}
                {promptArea}
            </div>
            {disclaimer}
        </div>
    )
}